import * as tslib_1 from "tslib";
import { put } from 'redux-saga/effects';
import { initCustomSetDeviationStream, initGallectionStream, initBrowseStream, initGallectionDeviationStream, } from '../actions';
import { MediaSourceType } from '../types';
export default function (_a) {
    var mediaSource, gallectionFolder, gallectionFolders, initialDeviationSet;
    var payload = _a.payload;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!payload) {
                    return [2 /*return*/];
                }
                mediaSource = payload.mediaSource, gallectionFolder = payload.gallectionFolder, gallectionFolders = payload.gallectionFolders, initialDeviationSet = payload.initialDeviationSet;
                if (![
                    MediaSourceType.GALLERY,
                    MediaSourceType.COLLECTION,
                    MediaSourceType.STASH,
                ].includes(mediaSource)) return [3 /*break*/, 4];
                if (!gallectionFolder) return [3 /*break*/, 2];
                return [4 /*yield*/, put(initGallectionDeviationStream())];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [4 /*yield*/, put(initGallectionStream({ gallectionFolders: gallectionFolders }))];
            case 3:
                _b.sent();
                return [3 /*break*/, 8];
            case 4:
                if (!(mediaSource === MediaSourceType.BROWSE)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(initBrowseStream())];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6:
                if (!(mediaSource === MediaSourceType.CUSTOM_SET &&
                    initialDeviationSet)) return [3 /*break*/, 8];
                return [4 /*yield*/, put(initCustomSetDeviationStream(initialDeviationSet))];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=initMediaPopup.js.map